import { useTranslation } from "react-i18next";
import FunctionalButton from "components/layout/FunctionalButton";
import { useNavigateToPose } from "providers/navigation/NavigateToPoseProvider";

const STAGE_I18N_KEYS = new Set([
    "recovery_backup",
    "recovery_wait",
    "recovery_clearing",
    "following_recovery",
    "following_retry_wait",
    "following",
    "planning_retry_wait",
    "planning_navfn",
    "planning_clear_global",
    "planning",
    "navigating",
]);

const NavigateToPoseBanner = () => {
    const { t } = useTranslation(["navigation", "common"]);
    const {
        showNavigateToPoseBanner,
        cancelNavigateToPose,
        navigationStage,
        distanceRemaining,
    } = useNavigateToPose();

    if (!showNavigateToPoseBanner) {
        return null;
    }

    const stageKey = STAGE_I18N_KEYS.has(navigationStage)
        ? navigationStage
        : "navigating";
    const stageLabel = t(`navigation:stages.${stageKey}`);
    const statusLabel =
        distanceRemaining != null
            ? t("navigation:statusWithDistance", {
                  stage: stageLabel,
                  meters: distanceRemaining.toFixed(1),
              })
            : stageLabel;

    return (
        <div
            className="pointer-events-auto absolute left-1/2 top-2 z-[100] flex -translate-x-1/2 items-center gap-3 rounded-r10 border border-black80 bg-black90 px-4 py-2 shadow-lg"
            role="status"
        >
            <span className="text-h5 whitespace-nowrap">{statusLabel}</span>
            <FunctionalButton
                title={t("common:cancel")}
                className="shrink-0 rounded-r5 border border-red-600 bg-red-600 px-3 py-1 text-h5 text-white hover:border-red-500 hover:bg-red-500"
                onClick={() => {
                    cancelNavigateToPose();
                }}
            />
        </div>
    );
};

export default NavigateToPoseBanner;
